/**
 * Simple text rotator for quotes within <li> tags
 */
(function() {
    'use strict';

    /**
     * Odigeo.UIElements.enhanceTextRotator()
     * @param {object} el - main DOM wrapper
     * @param {boolean} autostart - manual or automatic cycle start
     * @param {number} fadeTime - transition time between cycles in ms
     * @param {number} delayTime - time between end of transition and next transition in ms
     * @return {*}
     */
    Odigeo.UIElements.enhanceTextRotator = function(el, autostart, fadeTime, delayTime) {
        var $el = el;
        var quoteInterval = null;
        var _play;
        var _pause;
        var _destroy;
        var _quoteFadeIn;
        var _quoteFadeOut;
        var _calculateQuotes;
        var $quotes = $el.find('li');
        var quoteIndex = 0;

        autostart = autostart || false;
        fadeTime = fadeTime || 100;
        delayTime = delayTime || 1000;

        if (typeof this.instance === 'object') {
            if (autostart) {
                this.instance.play();
            }
            return this.instance;
        }

        // private methods
        /**
         * _quoteFadeIn() make a fade in and calls play()
         * @private
         */
        _quoteFadeIn = function() {
            _calculateQuotes().fadeIn();
            _play();
        };

        /**
         *  _quoteFadeOut() is a transition from fadeOut
         *  to fadein while passing to the next quote
         * @private
         */
        _quoteFadeOut = function() {
            _calculateQuotes().fadeOut();
            quoteIndex++;
            quoteInterval = setTimeout(_quoteFadeIn, fadeTime);
        };

        /**
         * _calculateQuotes() returns de quotes left to end the cycle
         * @return {object}
         * @private
         */
        _calculateQuotes = function() {
            return $quotes.eq(quoteIndex % $quotes.length);
        };

        // exposed methods
        /**
         * _pause() pauses rotator
         */
        _pause = function() {
            clearTimeout(quoteInterval);
            quoteInterval = null;
        };
        /**
         *  _play() plays rotator
         */
        _play = function() {
            quoteInterval = setTimeout(_quoteFadeOut, fadeTime + delayTime);
        };

        /**
         * destroys timeout resets inline styles for li elements
         * and destroys singleton
         * when going to results page
         * @private
         */
        _destroy = function() {
            _pause();
            $quotes.removeAttr('style');
        };

        /**
         * Exposed Methods by module
         * @return {{play: _play, pause: _pause, destroy: _destroy}}
         * @constructor
         */
        function Module() {
            return {
                play: _play,
                pause: _pause,
                destroy: _destroy,
            };
        }

        this.instance = new Module();

        if (autostart) {
            _play();
        }

        return this.instance;
    };
}());
